import CostsTableField from '@/modules/document/_component/fields/CostsTableField.vue';
import ResourcesTableField from '@/modules/document/_component/fields/ResourcesTableField.vue';

const types = [
    {
        text: 'Event name',
        value: 'event.name',
    },
    {
        text: 'Event type',
        value: 'event.type.name',
    },
    {
        text: 'Event description',
        value: 'event.description',
    },
    {
        text: 'Start date',
        value: 'event.start_date',
    },
    {
        text: 'Start time',
        value: 'event.start_time',
    },
    {
        text: 'End date',
        value: 'event.end_date',
    },
    {
        text: 'End time',
        value: 'event.end_time',
    },
    {
        text: 'Guests',
        value: 'event.guests',
    },
    {
        text: 'Client account name',
        value: 'event.account.name',
    },
    {
        text: 'Client account address',
        value: 'event.account.address',
    },
    {
        text: 'Client contact name',
        value: 'event.contact.name',
    },
    {
        text: 'Client contact email address',
        value: 'event.contact.email',
    },
    {
        text: 'Client contact phone',
        value: 'event.contact.phone',
    },
    {
        text: 'Client contact mobile',
        value: 'event.contact.mobile',
    },
    {
        text: 'Client decision date',
        value: 'event.estimated_contracted_date',
    },
    {
        text: 'Venue name',
        value: 'event.venue.name',
    },
    {
        text: 'Venue address',
        value: 'event.venue.address',
    },
    {
        text: 'Agency name',
        value: 'event.agentAccount.name',
    },
    {
        text: 'Event managers',
        value: 'event.managers_string',
    },
    {
        text: 'Salespeople',
        value: 'event.salespeople_string',
    },
    {
        text: 'Costs',
        value: 'event.costs',
        type: 'table',
        columns: [
            {
                text: 'Cost type',
                value: 'cost.type.name',
            },
            {
                text: 'Description',
                value: 'cost.description',
            },
            {
                text: 'Quantity',
                value: 'cost.quantity',
            },
            {
                text: 'Unit cost',
                value: 'cost.unit_cost',
            },
            {
                text: 'Total price',
                value: 'cost.total_price',
            },
            {
                text: 'Unit price',
                value: 'cost.unit_price',
            },
            {
                text: 'Total price',
                value: 'cost.total_price',
            },
        ],
        optionsComponent: CostsTableField,
    },
    {
        text: 'Resources',
        value: 'event.resources',
        type: 'table',
        columns: [
            {
                text: 'Resource type',
                value: 'allocation.resource_type_name',
            },
            {
                text: 'Name',
                value: 'allocation.resource_name',
            },
            {
                text: 'Description',
                value: 'allocation.resource_description',
            },
            {
                text: 'SKU',
                value: 'allocation.resource_sku',
            },
            {
                text: 'Quantity',
                value: 'allocation.quantity',
            },
            {
                text: 'Unit cost',
                value: 'allocation.unit_cost',
            },
            {
                text: 'Total cost',
                value: 'allocation.total_cost',
            },
            {
                text: 'Unit price',
                value: 'allocation.unit_price',
            },
            {
                text: 'Total price',
                value: 'allocation.total_price',
            },
        ],
        optionsComponent: ResourcesTableField,
    },
    {
        text: 'Job sheet notes',
        value: 'event.job-sheet-notes',
        type: 'table',
    },
];

export default types;
